import React, { createContext, useCallback, useContext, useState } from 'react';

// Notificaciones tipo toast para reemplazar los alert() del navegador.
// Uso: const { mostrarToast } = useToast(); mostrarToast('¡Guardado!', 'exito');

const ToastContext = createContext(null);

const estilos = {
  exito: { fondo: '#D1FAE5', borde: '#059669', texto: '#065F46', icono: '✅' },
  error: { fondo: '#FEE2E2', borde: '#DC2626', texto: '#991B1B', icono: '⚠️' },
  info: { fondo: '#DBEAFE', borde: '#2563EB', texto: '#1E40AF', icono: 'ℹ️' },
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const mostrarToast = useCallback((mensaje, tipo = 'info', duracionMs = 4000) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, mensaje, tipo }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duracionMs);
  }, []);

  return (
    <ToastContext.Provider value={{ mostrarToast }}>
      {children}
      <div style={{ position: 'fixed', top: '16px', left: '50%', transform: 'translateX(-50%)', zIndex: 2000, display: 'flex', flexDirection: 'column', gap: '8px', width: 'min(420px, calc(100vw - 32px))' }}>
        {toasts.map((t) => {
          const s = estilos[t.tipo] || estilos.info;
          return (
            <div key={t.id} style={{ backgroundColor: s.fondo, border: `1px solid ${s.borde}`, color: s.texto, borderRadius: '10px', padding: '12px 16px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', fontSize: '14px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{s.icono}</span>
              <span>{t.mensaje}</span>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast debe usarse dentro de <ToastProvider>');
  return ctx;
}
